import { render } from "./FridgeDetailsSelectHours.vue?vue&type=template&id=b0c9001e&ts=true"
import script from "./FridgeDetailsSelectHours.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsSelectHours.vue?vue&type=script&lang=ts"

import "./FridgeDetailsSelectHours.vue?vue&type=style&index=0&id=b0c9001e&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__